export enum IcePieSegmentColorCodesEnum {
    EXPORTED_OK = '#a9eba7',
    TOO_SMALL_BAD_CHAIN = '#a7ebe3',
    RESTRICTED_CATEGORY_BAD_PID = '#a7b3eb',
    ASPECT_RATIO_OTHER = '#d3a7eb',
    UNCATEGORIZED = '#eba7b5',
}

export enum VisualsDashboardSegmentColorEnum {
    GREEN = '#4ade80',
    CYAN = '#5eead4',
    BLUE = '#818cf8',
    PURPLE = '#c084fc',
    PINK = '#f472b6',
}

export const IcePieSegmentsToDashboardSegmentsColorMap: Record<IcePieSegmentColorCodesEnum, VisualsDashboardSegmentColorEnum> = {
    [IcePieSegmentColorCodesEnum.EXPORTED_OK]: VisualsDashboardSegmentColorEnum.GREEN,
    [IcePieSegmentColorCodesEnum.TOO_SMALL_BAD_CHAIN]: VisualsDashboardSegmentColorEnum.CYAN,
    [IcePieSegmentColorCodesEnum.RESTRICTED_CATEGORY_BAD_PID]: VisualsDashboardSegmentColorEnum.BLUE,
    [IcePieSegmentColorCodesEnum.ASPECT_RATIO_OTHER]: VisualsDashboardSegmentColorEnum.PURPLE,
    [IcePieSegmentColorCodesEnum.UNCATEGORIZED]: VisualsDashboardSegmentColorEnum.PINK,
};
